export enum VenueWebsocketMessage {
	VENUEMESSAGES = "venueMessage",
	MENUPDATE = "menuUpdate",
	INTEGRATORUPDATE = "integratorUpdate",
	SALESUPDATE = "salesUpdate",
	LABORUPDATE = "laborUpdate",
}
